import React from 'react'
import { Badge, Table, color, fontWeight } from 'stylist'
import styled from 'react-emotion'
import { friendlyDateTime } from 'utils/time'
import { Link } from 'react-router-dom'

const StyledTable = styled(Table)`
  text-align: left;
  td:not(:first-child) {
    white-space: nowrap;
    width: 1px;
  }
`

const MutedText = styled.span`
  color: ${color('pewter')};
`

const VideoLink = styled(Link)`
  color: ${color('ocean')};
  ${fontWeight('bold')};
  &:hover {
    text-decoration: underline;
  }
`

const VideosTable = ({ videos: { edges }, path }) => (
  <StyledTable data={edges.map(({ node }) => node)} type="flat">
    <Table.Row>
      <Table.Column
        label="Video Name"
        render={({ title, id }) => (
          <VideoLink to={`${path}/${id}`}>{title}</VideoLink>
        )}
      />

      <Table.Column
        label="Created"
        render={({ insertedAt }) => (
          <MutedText>{friendlyDateTime(insertedAt)}</MutedText>
        )}
      />
      <Table.Column
        label="Status"
        render={({ clips }) =>
          clips.edges.length ? (
            <Badge color="pewter" solid>
              Complete
            </Badge>
          ) : (
            <Badge color="slate">Processing</Badge>
          )
        }
      />
    </Table.Row>
  </StyledTable>
)

export default VideosTable



// WEBPACK FOOTER //
// ./src/routes/videos/components/VideosTable.js